module.exports = __webpack_public_path__ + "static/media/exitfund_logo.b23592c7.jpg";